module.exports = __webpack_public_path__ + "static/sangria.c90461a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sangria.svg
// module id = ./src/assets/icons/sangria.svg
// module chunks = 0 1